import { bind } from '../decorators';
import { createLogger } from '../loggerFacade';

const logger = createLogger('wake-lock-manager');

export class WakeLockManager {
    static isWakeLockSupported(): boolean {
        return 'wakeLock' in navigator && 'request' in navigator.wakeLock;
    }
    private wakeLockSentinel: WakeLockSentinel | null = null;
    private abortController: AbortController | null = null;
    @bind
    public async requestWakeLock(): Promise<void> {
        await this.request();
        this.subscribeWakeLock();
    }
    @bind
    public async releaseWakeLock() {
        this.abortIfExists();
        if (this.wakeLockSentinel) {
            await this.wakeLockSentinel.release();
            this.unsubscribeWakeLock();
        }
    }

    @bind
    private async handleVisibilityChange() {
        if (this.wakeLockSentinel !== null && document.visibilityState === 'visible') {
            await this.request();
        }
    }
    @bind
    private subscribeWakeLock() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('fullscreenchange', this.handleVisibilityChange);
    }
    @bind
    private unsubscribeWakeLock() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('fullscreenchange', this.handleVisibilityChange);
    }

    @bind
    private abortIfExists() {
        if (this.abortController && !this.abortController.signal.aborted) {
            this.abortController.abort();
        }
    }

    @bind
    private async request() {
        try {
            this.abortIfExists();
            this.abortController = new AbortController();

            // @ts-expect-error
            this.wakeLockSentinel = await navigator.wakeLock.request('screen', this.abortController);
        } catch (error) {
            logger.warn(error, {
                method: 'requestWakeLock',
                additional: {
                    isWakeLockSupported: WakeLockManager.isWakeLockSupported(),
                },
            });
        }
    }
}
